// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bg-logo-common.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/bg-logo-common-sm.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFoundPage_not-found__4sePW {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: #f5f5ff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.NotFoundPage_content__jPnhp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.NotFoundPage_title__bXj3q {
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 28px;
  line-height: 48px;
  color: #00007a;
}

.NotFoundPage_subtitle__qetGt {
  margin-bottom: 40px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}

.NotFoundPage_button__CCCqU {
  padding: 6px 31px;
}

@media screen and (max-width: 600px) {
  .NotFoundPage_not-found__4sePW {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: bottom;
    background-size: 100%;
  }
  .NotFoundPage_not-found__4sePW .NotFoundPage_content__jPnhp {
    width: 100%;
    padding: 10% 20px 20px 20px;
    padding-bottom: 120px;
  }
  .NotFoundPage_not-found__4sePW .NotFoundPage_title__bXj3q {
    font-size: 20px;
    line-height: 36px;
  }
  .NotFoundPage_not-found__4sePW .NotFoundPage_subtitle__qetGt {
    margin-bottom: 32px;
  }
  .NotFoundPage_not-found__4sePW .NotFoundPage_button__CCCqU {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NotFoundPage/NotFoundPage.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,yBCTS;EDUT,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAIF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtBS;AD0BX;;AADA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,iBAAA;AAIF;;AADA;EACE;IACE,yDAAA;IACA,2BAAA;IACA,qBAAA;EAIF;EAFE;IACE,WAAA;IACA,2BAAA;IACA,qBAAA;EAIJ;EADE;IACE,eAAA;IACA,iBAAA;EAGJ;EAAE;IACE,mBAAA;EAEJ;EACE;IACE,WAAA;EACJ;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.not-found {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n  background-color: colors.$primary1;\n  background-image: url(../../assets/bg-logo-common.svg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.title {\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 48px;\n  color: colors.$primary8;\n}\n\n.subtitle {\n  margin-bottom: 40px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n}\n\n.button {\n  padding: 6px 31px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .not-found {\n    background-image: url(../../assets/bg-logo-common-sm.svg);\n    background-position: bottom;\n    background-size: 100%;\n\n    .content {\n      width: 100%;\n      padding: 10% 20px 20px 20px;\n      padding-bottom: 120px;\n    }\n\n    .title {\n      font-size: 20px;\n      line-height: 36px;\n    }\n\n    .subtitle {\n      margin-bottom: 32px;\n    }\n\n    .button {\n      width: 100%;\n    }\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"not-found": `NotFoundPage_not-found__4sePW`,
	"content": `NotFoundPage_content__jPnhp`,
	"title": `NotFoundPage_title__bXj3q`,
	"subtitle": `NotFoundPage_subtitle__qetGt`,
	"button": `NotFoundPage_button__CCCqU`
};
export default ___CSS_LOADER_EXPORT___;
